import { useFormContext } from 'react-hook-form';

const Checkbox = ({
                    name,
                    label,
                    helpText,
                    validationRules = {}
                  }) => {
  const { register, formState: { errors } } = useFormContext();
  const registration = register(name, validationRules);

  return (
      // Bootstrap's .form-check applies padding-left (1.5em) expecting the input to be a
      // direct sibling of the label, compensated by a negative margin-left on
      // .form-check-input. Here the input is nested inside the label instead, and the
      // input's own inline `margin: 0` (below) wins over that compensating negative margin
      // by specificity — so without cancelling the padding here too, the whole row drifts
      // right instead of lining up flush with the fields above it.
      <div className="form-check" style={{ display: 'flex', flexDirection: 'column', paddingLeft: 0 }}>
        <label
            style={{ display: 'flex', alignItems: 'center', gap: '9px', cursor: 'pointer' }}
            className={errors?.[name] ? 'is-invalid' : ''}
        >
          <input
              type="checkbox"
              className="form-check-input"
              style={{ float: 'none', margin: 0 }}
              {...registration}
          />
          {label && (
              <span
                  className="form-check-label small"
                  style={{ paddingTop: '2px', userSelect: 'none' }}
              >
            {label}
          </span>
          )}
        </label>

        {/* text-muted sous le label */}
        {helpText && (
            <small className="form-text text-muted">
              {helpText}
            </small>
        )}

        {errors?.[name] && (
            <div className="invalid-feedback" style={{ marginInlineStart: '25px' }}>
              {errors[name].message}
            </div>
        )}
      </div>
  );
};

export default Checkbox;
